import React from 'react';
import { ThemeProvider } from './ThemeContext';
import { ToastProvider } from './ToastContext';
import { AuthProvider } from './auth';
import { GamificationProvider } from './GamificationContext';
import { WalletProvider } from './WalletContext';

export const CoreProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ThemeProvider>
    <ToastProvider>
      <AuthProvider>
        <GamificationProvider>
          <WalletProvider>
            {children}
          </WalletProvider>
        </GamificationProvider>
      </AuthProvider>
    </ToastProvider>
  </ThemeProvider>
);
